import { RootState } from "../../../redux-store";

export const selectDraftCargoEquipment = (state: RootState) =>
  state.data.draftCargoEquipment.picks;
